import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA4_ID;

// Load GA4 script once
let loaded = false;
const loadGA = () => {
  if (loaded || !GA_ID) return;
  loaded = true;

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
};

// Track page views on route change
export const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA_ID) return;
    loadGA();
    window.gtag("event", "page_view", {
      page_path: location.pathname,
      page_title: document.title,
    });
  }, [location]);
};

// Track custom events (e.g. form submission)
export const trackEvent = (eventName, params = {}) => {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", eventName, params);
};

// Component to mount in App (inside BrowserRouter)
const Analytics = () => {
  usePageView();
  return null;
};

export default Analytics;
